import { render, staticRenderFns } from "./login_mobile.vue?vue&type=template&id=ddcd5d7e&scoped=true"
import script from "./login_mobile.vue?vue&type=script&lang=js"
export * from "./login_mobile.vue?vue&type=script&lang=js"
import style0 from "./login_mobile.vue?vue&type=style&index=0&id=ddcd5d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd5d7e",
  null
  
)

export default component.exports